import { useTheme } from "@mui/material/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { BellIcon, CircleCheck } from "../../../../assets/icons";
import { MySurveySummaryDTO } from "../../../../models/my-survey-summary/my-survey-summary-dto";
import CircleAndIconContainer from "../../reusable-widget-link-components/CircleAndIconContainer/CircleAndIconContainer";

const NotStartedLink = ({ customSummary, loading }: { customSummary: MySurveySummaryDTO; loading: boolean }) => {
  const tRP = "components.custom_widget_links.my_surveys.not_started";
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <CircleAndIconContainer
      mainInfo={customSummary?.notStarted?.toString() ?? "0"}
      description={`${t(`${tRP}`)}`}
      Icon={customSummary?.notStarted > 0 ? BellIcon : CircleCheck}
      IconStyle={{
        color: customSummary?.notStarted > 0 ? theme.palette.error.main : theme.palette.success.light,
        width: "90%",
        height: "90%",
      }}
      loading={loading}
      {...(customSummary?.notStarted > 0 && {
        animateIcon: true,
      })}
    />
  );
};
export default NotStartedLink;
